import { combineReducers } from 'redux'
import {
	bankSlice,
	gosbSlice,
	sectorSlice,
	channelSlice,
	specialOfferSlice,
	channelStructureSlice,
	citiesSlice,
	regionSlice,
} from 'Pages/referenceBooks'

export const referenceBooks = combineReducers({
	[bankSlice.name]: bankSlice.reducer,
	[gosbSlice.name]: gosbSlice.reducer,
	[sectorSlice.name]: sectorSlice.reducer,
	[channelSlice.name]: channelSlice.reducer,
	[specialOfferSlice.name]: specialOfferSlice.reducer,
	[channelStructureSlice.name]: channelStructureSlice.reducer,
	[citiesSlice.name]: citiesSlice.reducer,
	[regionSlice.name]: regionSlice.reducer,
})
